import React from "react"

export default (props) => (
    <footer style={{
        width: `100%`,
        padding: `1rem 0`,
        background: `#fff`,
        borderTop: `1px solid #e3e3e3`
    }}>
        <p style={{
            maxWidth: `1000px`,
            margin: `0 auto`,
            fontSize: `12px`,
            textAlign: `center`
        }}>
           关于本站：专注收集各种gif图片。
        </p>
    </footer>
)